"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsDesktop = void 0;
var _mui = require("@ori-ui/mui");
const useIsDesktop = () => {
  const theme = (0, _mui.useTheme)();
  return (0, _mui.useMediaQuery)(theme.breakpoints.up('sm'));
};
exports.useIsDesktop = useIsDesktop;
